<template>
	<v-dialog v-model="exibirModal" persistent fullscreen scrollable transition="dialog-bottom-transition">
		<v-card>
			<div class="align-center d-flex pa-4 primary">
				<v-row
					class="white--text"
					style="cursor: pointer"
					align="center"
					no-gutters
					@click="$emit('fechar-modal-edocs')"
				>
					<v-icon class="mr-1" size="16" color="white">mdi-arrow-left</v-icon> Voltar para Ata
				</v-row>
			</div>

			<v-card-text class="pa-6" :style="{ overflow: 'hidden' }">
				<iframe
					class="arp-iframe"
					:src="`/flowbee/#/processos/${idProcessoDigital}/sincronizacao/e-docs`"
				></iframe>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'modal-edocs',
	props: {
		exibir: {
			type: Boolean,
		},
		idProcessoDigital: {
			type: String,
			required: true,
		},
	},
	data() {
		return {}
	},
	computed: {
		exibirModal() {
			return this.exibir
		},
	},
}
</script>
